module.exports = __webpack_public_path__ + "static/media/1168654.161e1cec.svg";